import { forwardRef, useEffect, useState } from 'react'
import { getPasswordClassName } from '../../helpers/utils'

const Text = forwardRef(({ item, ...props }, ref) => {
    let { label, name, register, setValue, shouldShowStrength = false } = props
    name = name || label || item.name

    const [password, setPassword] = useState('')
    const [strengthClasses, setStrengthClasses] = useState([])
    const [strength, setStrength] = useState('')

    const isPassword = item?.type === 'password'

    useEffect(() => {
        if (setValue && name) {
            setValue(name, item.defaultValue)
        }
    }, [item, name, setValue])

    const onChange = (e) => {
        if (shouldShowStrength) {
            setPassword(e.target.value)
        }
    }

    useEffect(() => {
        const [classNames, strength] = getPasswordClassName(password)
        setStrengthClasses(classNames)
        setStrength(strength)
    }, [password])

    if (!name) return null

    const hasDescription = Boolean(item?.description)
    const isNumericInput = item?.specificType === 'number'

    return (
        <div className="mb-[11px]">
            {item.type !== 'hidden' && (
                <label className="mb-1.5 block text-xs font-semibold uppercase tracking-[0.04em] text-gray-500">
                    {item?.label ?? label}
                    {item?.required && (
                        <span className="text-[#ED5C2F]"> *</span>
                    )}
                </label>
            )}

            <div key={item.defaultValue}>
                {hasDescription && (
                    <p className="mb-3 text-[13px] leading-[1.55] text-gray-500">
                        {item.description}
                    </p>
                )}
                <input
                    ref={ref}
                    {...register(name, {
                        onChange,
                    })}
                    type={item?.specificType || item?.type}
                    placeholder={item?.placeholder}
                    className={`w-full rounded-[10px] border border-[#E1DACE] bg-white px-[14px] py-[13px] text-[14.5px] text-olm-black shadow-none transition-all duration-150 focus:border-[#F28230] focus:outline-none focus:ring-4 focus:ring-[#F28230]/15 ${
                        isNumericInput ? 'max-w-full' : ''
                    }`}
                    autoComplete="chrome-off"
                />
                {shouldShowStrength && isPassword && (
                    <span className={`mt-2 block text-sm ${strengthClasses}`}>
                        {strength}
                    </span>
                )}
            </div>
        </div>
    )
})

Text.displayName = 'Text'

export { Text }
